<div class="comment-holder">
  <div class="comment-content">
    <fieldset>
      <div class="comment-text-box">
        <label class="sr-only" for="free-text">{{ placeHolder | translate }}:</label>
        <textarea rlFocusMe rlStopPropagation class="form-control" [(ngModel)]="comment.title" id="free-text" placeholder="{{ placeHolder | translate }}" [attr.aria-label]="placeHolder | translate" rows="4" aria-describedby="save-error"></textarea>
        <div *ngIf="errorMsg" id="save-error" class="input-error-message error-message" aria-live="assertive" aria-describedby="">
          {{ errorMsg | translate }}
        </div>
        <div class="comment-text-btns">
          <div class="justify-content">
            <div class="flex-start">
              <button rlStopPropagation type="button" class="btn btn-default" (click)="cancel()" id="cancel" [rlAria]="'general.cancel' | translate">
                {{ 'general.cancel' | translate }}
              </button>
            </div>
            <div class="flex-end">
              <button rlStopPropagation type="button" class="btn btn-primary" (click)="save(comment)" id="save" [attr.aria-label]="(visibility === 'PRIVATE' ? 'general.save' : 'general.publish') | translate">
                {{ (visibility === 'PRIVATE' ? 'general.save' : 'general.publish') | translate }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </fieldset>
  </div>
</div>
